// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.System_systemCard__P64Bf {
  margin-bottom: 20px;
}
.System_systemCard__P64Bf .ant-card-head-title {
  font-weight: bold;
}

.System_filterInfo__WH8ec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 8px 16px;
  background-color: #f0f8ff;
  border-radius: 4px;
}

.System_bootParamsContainer__mm8-i {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.System_bootParam__xDhOm {
  font-family: monospace;
  margin: 4px;
}

.System_rawParams__YZxgJ {
  margin-top: 16px;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.System_rawParamsText__idjo0 {
  font-family: monospace;
  margin-top: 8px;
  word-break: break-all;
}

.System_tunedContainer__tMq6u {
  padding: 16px 0;
}

.System_activeProfile__lbjjT {
  margin-bottom: 16px;
}

.System_activeTag__8wSSl {
  font-size: 16px;
  padding: 4px 12px;
  margin-top: 8px;
}

.System_availableProfiles__0i6\\+a {
  margin-top: 16px;
}

.System_activeItem__2N54o {
  background-color: #f6ffed;
}

.System_processStatusRunning__f7aXy {
  color: #52c41a;
}

.System_processStatusSleeping__FiUCS {
  color: #1890ff;
}

.System_processStatusStopped__Ft2Di {
  color: #faad14;
}

.System_processStatusZombie__0yoar {
  color: #ff4d4f;
}`, "",{"version":3,"sources":["webpack://./src/pages/Detail/component/system/System.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAEI;EACE,iBAAA;AAAN;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,mBAAA;AAFF;;AAKA;EACE,sBAAA;EACA,WAAA;AAFF;;AAKA;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,sBAAA;EACA,eAAA;EACA,qBAAA;AAFF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;AAFF;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF","sourcesContent":[".systemCard {\n  margin-bottom: 20px;\n  \n  :global {\n    .ant-card-head-title {\n      font-weight: bold;\n    }\n  }\n}\n\n.filterInfo {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding: 8px 16px;\n  background-color: #f0f8ff;\n  border-radius: 4px;\n}\n\n.bootParamsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.bootParam {\n  font-family: monospace;\n  margin: 4px;\n}\n\n.rawParams {\n  margin-top: 16px;\n  padding: 12px;\n  background-color: #f9f9f9;\n  border-radius: 4px;\n}\n\n.rawParamsText {\n  font-family: monospace;\n  margin-top: 8px;\n  word-break: break-all;\n}\n\n.tunedContainer {\n  padding: 16px 0;\n}\n\n.activeProfile {\n  margin-bottom: 16px;\n}\n\n.activeTag {\n  font-size: 16px;\n  padding: 4px 12px;\n  margin-top: 8px;\n}\n\n.availableProfiles {\n  margin-top: 16px;\n}\n\n.activeItem {\n  background-color: #f6ffed;\n}\n\n.processStatusRunning {\n  color: #52c41a;\n}\n\n.processStatusSleeping {\n  color: #1890ff;\n}\n\n.processStatusStopped {\n  color: #faad14;\n}\n\n.processStatusZombie {\n  color: #ff4d4f;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"systemCard": `System_systemCard__P64Bf`,
	"filterInfo": `System_filterInfo__WH8ec`,
	"bootParamsContainer": `System_bootParamsContainer__mm8-i`,
	"bootParam": `System_bootParam__xDhOm`,
	"rawParams": `System_rawParams__YZxgJ`,
	"rawParamsText": `System_rawParamsText__idjo0`,
	"tunedContainer": `System_tunedContainer__tMq6u`,
	"activeProfile": `System_activeProfile__lbjjT`,
	"activeTag": `System_activeTag__8wSSl`,
	"availableProfiles": `System_availableProfiles__0i6+a`,
	"activeItem": `System_activeItem__2N54o`,
	"processStatusRunning": `System_processStatusRunning__f7aXy`,
	"processStatusSleeping": `System_processStatusSleeping__FiUCS`,
	"processStatusStopped": `System_processStatusStopped__Ft2Di`,
	"processStatusZombie": `System_processStatusZombie__0yoar`
};
export default ___CSS_LOADER_EXPORT___;
